import { Api } from '@shared/constants/common-field.constants';
import {IPlatformApiProvider} from '@shared/services/platform-api-provider';

export class SecurityApiDataProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.startsWith('/users')) {
      return Api.Security;
    }
    if (url.startsWith('/security')) {
      return Api.Security;
    }
  }
}
